<template>
  <div class="simple-layout">
    <SimpleHeader />
    <Sidebar />
    <Attention />
    <div class="main">
      <Notifications />
      <slot />
    </div>
    <Footer />
  </div>
</template>

<script>
import Sidebar from '../components/layouts/Sidebar.vue';
import SimpleHeader from '../components/layouts/SimpleHeader.vue';
import Notifications from '../components/layouts/Notifications.vue';
import Attention from '../components/layouts/Attention.vue';
import Footer from '../components/layouts/Footer.vue';

export default {
  name: 'SimpleLayout',
  components: {
    Notifications,
    Attention,
    SimpleHeader,
    Sidebar,
    Footer,
  },
};
</script>
